import React, { Component } from "react";
import { Redirect } from 'react-router';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBIcon,
  //MDBInput,
  //MDBAnimation,
  MDBCard,
  MDBCardBody,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter
} from "mdbreact";
import DocsLink from "./../components/docsLink";
import SectionContainer from "./../components/sectionContainer";
import axios from 'axios';
import "./ScrollbarPage.css";
import logo1 from './unsaac.jpg';

class FormsPage extends Component {
  
  /*Iniciamos los estados*/
  state = {
    respuesta     : [],
    usuario       : "",
    claveanterior : "",    
    modal1        : false,
    modal2        : false,
    modal3        : false,
  };

  /*Valores asignados a los parametros de ingreso*/
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  acceder = async (event) => {
    event.preventDefault();

    await axios
      .post("http://remuneraciones.unsaac.edu.pe:3001/generarcontrasena", {
        method: "post",
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          usuario: this.state.usuario,
          clave: this.state.claveanterior,
        }),
      })
      .then(async (response) => {
        await this.setState({ respuesta: response.data });
      })
      .catch((error) => { });

    if (this.state.respuesta.length > 0) {
      console.log(this.state.respuesta);
      //var ventanita = this.state.respuesta.ventana;
      //var output = JSON.parse(this.state.respuesta);

      //console.log(this.state.respuesta[0].modal1);
      if (this.state.respuesta[0].modal1 === "true")
        this.setState({ modal1: true });
      if (this.state.respuesta[0].modal2 === "true")
        this.setState({ modal2: true });
    }

    this.setState({ usuario: "" });
    this.setState({ claveanterior: "" });
    //this.setState({ clavenuevo : ''})
    //this.setState({ ventanita : true})
    //console.log(this.state.respuesta);
  };

  //llamamos al a funcion tick
  tick() {
    window.location.reload();
  }

  toggle = (nr) => () => {
    let modalNumber = "modal" + nr;
    this.setState({
      [modalNumber]: !this.state[modalNumber],
    });
  };

  render() {
    return (
      <MDBContainer className="mt-4">
        <SectionContainer header="Generar contraseña" noBorder>
          <MDBRow>
            <MDBCol md="4">
              <SectionContainer>
                <form>
                  {/* <p className="h5 text-center mb-4">Modulo para cambiar contraseña</p> */}
                  <div className="grey-text">
                    <MDBInput
                      label="Nro. de DNI"
                      icon="envelope"
                      group
                      validate
                      error="wrong"
                      success="right"
                      value={this.state.usuario}
                      onChange={this.onChange.bind(this)}
                      name="usuario"
                      id="usuario"
                      type="text"
                    />
                    <MDBInput
                      label="Cod. Boleta"
                      icon="envelope"
                      group
                      validate
                      error="wrong"
                      success="right"
                      value={this.state.claveanterior}
                      onChange={this.onChange.bind(this)}
                      name="claveanterior"
                      id="claveanterior"
                      type="password"
                    />
                  </div>
                  <div className="text-center">
                    <MDBBtn onClick={this.acceder.bind(this)}>Generar</MDBBtn>
                  </div>
                </form>
              </SectionContainer>
            </MDBCol>
            <MDBCol md="6">
              <div>
                <img src={logo1} width="400" height="250" />
              </div>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol md="4">
              <SectionContainer noBorder header="">
                {/* MODAL DE EXITO */}
                <MDBModal
                  className="modal-notify modal-info text-white"
                  isOpen={this.state.modal1}
                  toggle={this.toggle(1)}
                >
                  <MDBModalHeader
                    className="text-center"
                    titleClass="w-100"
                    tag="p"
                  >
                    INFORMACION
                  </MDBModalHeader>
                  <MDBModalBody className="text-center">
                    <MDBIcon
                      icon="bell"
                      size="4x"
                      className="animated rotateIn mb-4"
                    />
                    {this.state.respuesta.map((select) => (
                      <tr key={select.trabajador}>
                        <td>{select.informacion}</td>
                      </tr>
                    ))}
                  </MDBModalBody>
                  <MDBModalFooter className="justify-content-center">
                    <MDBBtn color="primary" onClick={this.toggle(1)}>
                      Salir
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>
                {/* MODAL ERROR */}
                <MDBModal
                  modalStyle="danger"
                  className="text-white"
                  size="sm"
                  side
                  position="top-right"
                  backdrop={false}
                  isOpen={this.state.modal2}
                  toggle={this.toggle(2)}
                >
                  <MDBModalHeader
                    className="text-center"
                    titleClass="w-100"
                    tag="p"
                    toggle={this.toggle(2)}
                  >
                    ADVERTENCIA?
                  </MDBModalHeader>
                  <MDBModalBody className="text-center">
                    <MDBIcon
                      icon="times"
                      size="4x"
                      className="animated rotateIn"
                    />
                    {this.state.respuesta.map((select) => (
                      <tr key={select.trabajador}>
                        <td>{select.informacion}</td>
                      </tr>
                    ))}
                  </MDBModalBody>
                  <MDBModalFooter className="justify-content-center">
                    <MDBBtn color="danger" onClick={this.toggle(2)}>
                      Salir
                    </MDBBtn>
                  </MDBModalFooter>
                </MDBModal>
              </SectionContainer>
            </MDBCol>
          </MDBRow>
        </SectionContainer>
      </MDBContainer>
    );
  }
}

export default FormsPage;
